// /* eslint-disable react/prop-types */
// import React from 'react';

// const MonthlySectionTable = ({ tableData, months }) => {
//   const tableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     fontFamily: 'sans-serif',
//     minWidth: '600px',
//   };

//   const thStyle = {
//     border: '1px solid #ccc',
//     padding: '10px',
//     backgroundColor: '#d9d6d6',
//     fontWeight: 'bold',
//     textAlign: 'center',
//     whiteSpace: 'nowrap',
//   };

//   const tdStyle = {
//     border: '1px solid #ccc',
//     padding: '10px',
//     textAlign: 'center',
//     backgroundColor: '#d9f0cb',
//     whiteSpace: 'nowrap',
//   };

//   const sectionCellStyle = {
//     ...tdStyle,
//     backgroundColor: '#e7f0fb',
//     fontWeight: 'bold',
//   };

//   return (
//     <div
//       style={{
//         width: '100%',
//         overflowX: 'auto',
//         padding: '20px',
//         boxSizing: 'border-box',
//       }}
//     >
//       <table style={tableStyle}>
//         <thead>
//           <tr>
//             <th style={thStyle}>Section</th>
//             {months.map((month) => (
//               <th key={`header-${month}`} style={thStyle}>
//                 {month}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {tableData.map((row) => (
//             <tr key={`row-${row.section}`}>
//               <td style={sectionCellStyle}>{row.section}</td>
//               {months.map((month) => (
//                 <td key={`${row.section}-${month}`} style={tdStyle}>
//                   {row[month.toLowerCase()] || 'Nil'}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default MonthlySectionTable;

// ############# New code #################

/* eslint-disable react/prop-types */
// import React from 'react';

// const MonthlySectionTable = ({ tableData, months }) => {
//   const tableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     fontFamily: 'sans-serif',
//     minWidth: '600px',
//     fontSize: '11px', // ✅ smaller text for compact look
//   };

//   const thStyle = {
//     border: '1px solid #ccc',
//     padding: '6px 8px', // ✅ reduced padding
//     backgroundColor: '#d9d6d6',
//     fontWeight: 'bold',
//     textAlign: 'center',
//     whiteSpace: 'nowrap',
//     position: 'sticky', // ✅ keep header fixed when scrolling vertically
//     top: 0,
//     zIndex: 2,
//   };

//   const tdStyle = {
//     border: '1px solid #ccc',
//     padding: '6px 8px', // ✅ reduced padding
//     textAlign: 'center',
//     backgroundColor: '#d9f0cb',
//     whiteSpace: 'nowrap',
//   };

//   const sectionCellStyle = {
//     ...tdStyle,
//     backgroundColor: '#e7f0fb',
//     fontWeight: 'bold',
//   };

//   const containerStyle = {
//     width: '100%',
//     height: '300px', // ✅ fixed height
//     overflowX: 'auto', // ✅ horizontal scroll
//     overflowY: 'auto', // ✅ vertical scroll
//     paddingRight: '12px', // ✅ padding on right
//     boxSizing: 'border-box',
//   };

//   return (
//     <div style={containerStyle}>
//       <table style={tableStyle}>
//         <thead>
//           <tr>
//             <th style={thStyle}>Section</th>
//             {months.map((month) => (
//               <th key={`header-${month}`} style={thStyle}>
//                 {month}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {tableData.map((row) => (
//             <tr key={`row-${row.section}`}>
//               <td style={sectionCellStyle}>{row.section}</td>
//               {months.map((month) => (
//                 <td key={`${row.section}-${month}`} style={tdStyle}>
//                   {row[month.toLowerCase()] || 'Nil'}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default MonthlySectionTable;


/* eslint-disable react/prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/prop-types */
import React from 'react';

const MonthlySectionTable = ({ tableData, months }) => {
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: 'sans-serif',
    fontSize: '13px',
  };

  const reducedPadding = '4px 6px';

  const commonCellStyle = {
    border: '1px solid #ccc',
    padding: reducedPadding,
    textAlign: 'center',
    verticalAlign: 'middle',
  };

  const thStyle = {
    ...commonCellStyle,
    backgroundColor: '#d9d6d6',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    color:"#2d2d2d"
  };

  const tdStyle = {
    ...commonCellStyle,
    backgroundColor: '#d9f0cb',
  };

  const sectionCellStyle = {
    ...commonCellStyle,
    backgroundColor: '#e7f0fb',
    fontWeight: 'bold',
    position: 'sticky',
    left: 0,
    zIndex: 1,
  };

  const containerStyle = {
    width: '100%',
    height: '250px',
    overflowX: 'auto',
    overflowY: 'auto',
    paddingRight: '12px',
    boxSizing: 'border-box',
  };

  return (
    <div style={containerStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thStyle, position: 'sticky', left: 0, zIndex: 3, fontWeight:"bold", color:"black" }}>Section</th>
            {months.map((month) => (
              <th key={`header-${month}`} style={thStyle}>
                {month}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row) => (
            <tr key={`row-${row.section}`}>
              <td style={sectionCellStyle}>{row.section}</td>
              {months.map((month) => (
                <td key={`${row.section}-${month}`} style={tdStyle}>
                  {row[month.toLowerCase()] || 'Nil'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MonthlySectionTable;
